import UniversalCookie from 'universal-cookie';
import client from './apiClient';
import {
  TraceContextLogViewModel,
  TraceContextLogSummaryViewModel,
  SearchTraceLogRequest,
} from '../models/feeTracing';
import { Constants } from '../utils/constants';

const cookie = new UniversalCookie({ path: '/' });

client.interceptors.request.use(async (config) => {
  const tenantId: string | null | undefined = localStorage.getItem(Constants.authorization.tenantId) || null;
  const access_token: string | undefined = cookie.get(Constants.authorization.accessToken) || null;

  config.headers['X-TenantId'] = tenantId;
  config.headers['Authorization'] = `Bearer ${access_token}`;

  return config;
});

export const searchTraceLogs = async (type: string = 'Fees', params: SearchTraceLogRequest = {}): Promise<TraceContextLogSummaryViewModel[]> => {
  const { data } = await client.post<TraceContextLogSummaryViewModel[]>(`/trace-logs/${type}/search`, params);
  return data;
};

export const getTraceById = async (transactionId: string): Promise<TraceContextLogViewModel[]> => {
  const { data } = await client.get<TraceContextLogViewModel[]>(`/trace-logs/${transactionId}`);
  return data;
};

export const getFileContent = async (fileRecordId: string): Promise<string> => {
  const { data } = await client.get<string>(`/files/${fileRecordId}/content`, {
    responseType: 'text',
    transformResponse: [(data) => data],
  });
  return data;
};
